module.exports = ".navbar {\n  padding: 0;\n  height: 3rem;\n  background-color: #a9a9a9; }\n\n.brand-column {\n  background-color: #898989;\n  height: 3rem; }\n\n.right-column {\n  height: 3rem;\n  padding: 0 1rem; }\n\n.sign-out span {\n  display: none; }\n\n.sign-out:hover span {\n  display: inline; }\n\n.navbar-brand {\n  padding-top: 0;\n  padding-bottom: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/navbar.component.scss
// module id = 591
// module chunks = 1